<template>
  <form-modal @closeModal="onCloseModal">
    <note-form :customer="customer"/>
  </form-modal>
</template>

<script>
import NoteForm from '@/modules/notes/note-form'
import FormModal from '@/components/_shared/form-modal'

export default {
  name: 'NotesCreateView',
  components: {
    NoteForm,
    FormModal
  },
  computed: {
    customer () {
      return this.$store.getters['customers/item']
    }
  },
  methods: {
    onCloseModal () {
      this.$store.dispatch('app/toggleNotesPanel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/app/notes/notes-create-view.vue